export default "__VITE_ASSET__DcZyPd2$__"